var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgurl"},[_c('img',{staticClass:"img",attrs:{"src":_vm.$showUrl + _vm.url,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }